module.exports = __webpack_public_path__ + "img/map-shape1.4b98bca3.png";